import React from 'react'

import TemplateManagement from '../icons/svg/template'
import JobManagement from '../icons/svg/job-management'
import Report from '../icons/svg/report'

import * as routePaths from './routePaths'
import { isAdmin, isSupervisor } from '../common/functions'

const adminSidebarRouteChoices = [
  { 
    label: 'routeTitles.jobManagement',
    leftIcon: <JobManagement />,
    nodeId: '1',
    linkUrl: routePaths.todoComponent,
    hasChildren: true
  },
  { 
    label: 'routeTitles.allJobs',
    nodeId: '12',
    linkUrl: routePaths.AllJobs,
    isChild: true
  },
  {
    label: 'routeTitles.myJobs',
    nodeId: '13',
    linkUrl: routePaths.myJobs,
    isChild: true
  },
  {
    label: 'routeTitles.createNewJob',
    nodeId: '11',
    linkUrl: routePaths.createJob,
    isChild: true
  },
  {
    label: 'routeTitles.qualityCheck',
    nodeId: '14',
    linkUrl: routePaths.qualityCheck,
    isChild: true
  },
  {
    label: 'routeTitles.templateManagement',
    leftIcon: <TemplateManagement />,
    nodeId: '3',
    hasChildren: true
  },
  {
    label: 'routeTitles.createTemplate',
    nodeId: '31',
    linkUrl: routePaths.createTemplate,
    isChild: true
  },
  {
    // label: 'routeTitles.viewTemplateRoute',
    label: 'routeTitles.templateSearch',
    nodeId: '32',
    linkUrl: routePaths.templateSearch, 
    isChild: true
  },
  { 
    label: 'routeTitles.reportsKeystrokesCapture',
    leftIcon: <Report />,
    nodeId: '5',
    hasChildren: true
  },
  {
    label: 'routeTitles.customerReports',
    nodeId: '51',
    linkUrl: routePaths.customerReports,
    isChild: true
  },
  {
    label: 'routeTitles.employeeReports',
    nodeId: '52',
    linkUrl: routePaths.employeeReports,
    isChild: true
  },
]

const supervisorSidebarRouteChoices = [
  { 
    label: 'routeTitles.jobManagement',
    leftIcon: <JobManagement />,
    nodeId: '1',
    linkUrl: routePaths.todoComponent,
    hasChildren: true
  },
  { 
    label: 'routeTitles.allOpenJobs',
    nodeId: '11',
    linkUrl: routePaths.AllJobs,
    isChild: true
  },
  { 
    label: 'routeTitles.myJobs',
    nodeId: '12',
    linkUrl: routePaths.myJobs,
    isChild: true
  },
  {
    label: 'routeTitles.createNewJob',
    nodeId: '14',
    linkUrl: routePaths.createJob,
    isChild: true
  },
  { 
    label: 'routeTitles.qualityCheck',
    nodeId: '13',
    linkUrl: routePaths.qualityCheck,
    isChild: true
  },
  {
    label: 'routeTitles.templateManagement',
    leftIcon: <TemplateManagement />,
    nodeId: '3',
    hasChildren: true
  },
  {
    // label: 'routeTitles.viewTemplateRoute',
    label: 'routeTitles.templateSearch',
    nodeId: '32',
    linkUrl: routePaths.templateSearch, 
    isChild: true
  },
  { 
    label: 'routeTitles.reportsKeystrokesCapture',
    leftIcon: <Report />,
    nodeId: '5',
    hasChildren: true
  },
  {
    label: 'routeTitles.customerReports',
    nodeId: '51',
    linkUrl: routePaths.customerReports,
    isChild: true
  },
  {
    label: 'routeTitles.employeeReports',
    nodeId: '52',
    linkUrl: routePaths.employeeReports,
    isChild: true
  },
]

const userSidebarRouteChoices = [
  { 
    label: 'routeTitles.jobManagement',
    leftIcon: <JobManagement />,
    nodeId: '1',
    hasChildren: true
  },
  { 
    label: 'routeTitles.myJobs',
    nodeId: '11',
    linkUrl: routePaths.myJobs,
    isChild: true
  }
]

const additionalGivenPermissions = window.sessionStorage.getItem('additional-permissions-user')
if (additionalGivenPermissions !== 'undefined' && additionalGivenPermissions !== undefined) {
  const additionalPermissionsForUser = JSON.parse(additionalGivenPermissions)
  const indexOfviewAllJobs = additionalPermissionsForUser?.map(object => object.value).indexOf('viewAllJobs')
  const indexOfQualityCheck = additionalPermissionsForUser?.map(object => object.value).indexOf('qualityCheck')
  const indexOfViewProductivityReport = additionalPermissionsForUser?.map(object => object.value).indexOf('viewProductivityReport')
  const indexOfSearchTemplate = additionalPermissionsForUser?.map(object => object.value).indexOf('searchTemplate')
  const indexOfCreateJob = additionalPermissionsForUser?.map(object => object.value).indexOf('createJob')
  const indexOfCreateTemplate = additionalPermissionsForUser?.map(object => object.value).indexOf('createTemplate')
  
  if (additionalPermissionsForUser?.[indexOfCreateTemplate]?.enabled) {
    supervisorSidebarRouteChoices.splice(6, 0, {
      label: 'routeTitles.createTemplate',
      nodeId: '31',
      linkUrl: routePaths.createTemplate,
      isChild: true
    })   
  }
  if (additionalPermissionsForUser?.[indexOfviewAllJobs]?.enabled) {
    userSidebarRouteChoices.splice(1, 0, {
      label: 'routeTitles.allJobs',
      nodeId: '12',
      linkUrl: routePaths.AllJobs,
      isChild: true
    })   
  }
  if (additionalPermissionsForUser?.[indexOfCreateJob]?.enabled) {
    userSidebarRouteChoices.push({
      label: 'routeTitles.createNewJob',
      nodeId: '13',
      linkUrl: routePaths.createJob,
      isChild: true
    })   
  }
  if (additionalPermissionsForUser?.[indexOfQualityCheck]?.enabled) {
    userSidebarRouteChoices.push({
      label: 'routeTitles.qualityCheck',
      nodeId: '14',
      linkUrl: routePaths.qualityCheck,
      isChild: true
    })
  }
  if (additionalPermissionsForUser?.[indexOfSearchTemplate]?.enabled) {
    userSidebarRouteChoices.push({
      label: 'routeTitles.templateManagement',
      leftIcon: <TemplateManagement />,
      nodeId: '3',
      hasChildren: true
    }, {
      label: 'routeTitles.templateSearch',
      nodeId: '31',
      linkUrl: routePaths.templateSearch, 
      isChild: true
    })
  }
  if (additionalPermissionsForUser?.[indexOfViewProductivityReport]?.enabled) {
    userSidebarRouteChoices.push({ 
      label: 'routeTitles.reportsKeystrokesCapture',
      leftIcon: <Report />,
      nodeId: '5',
      hasChildren: true
    },
    {
      label: 'routeTitles.customerReports',
      nodeId: '51',
      linkUrl: routePaths.customerReports,
      isChild: true
    },
    {
      label: 'routeTitles.employeeReports',
      nodeId: '52',
      linkUrl: routePaths.employeeReports,
      isChild: true
    })
  }    
}

export const getSidebarRouteChoices = () =>
  isAdmin() ? adminSidebarRouteChoices : isSupervisor() ? supervisorSidebarRouteChoices : userSidebarRouteChoices

export const getSidebarRouteLandingPage = () =>
  isAdmin() ? routePaths.adminDashboard : isSupervisor() ? routePaths.supervisorDashboard : routePaths.userDashboard